import React from 'react';
import Checkbox from '../../../components/forms/Checkbox';
import Stars from '../../../components/stars/Stars';
import { t } from '../../../utilities/translator';

export default function MobileStars(props) {
  const { handleCheckbox, localFilter } = props;
  const name = t('secondaryFilter.property_class');

  const renderCheckbox = localFilter
    .map(({ value, label, active }, index) => (
      <Checkbox
        key={value}
        label={
          <div className="filter-stars">
            <Stars value={value} />
          </div>
        }
        checked={active}
        onChange={() => handleCheckbox(index)}
      />
    ))
    .reverse();

  return (
    <div className="filter-item">
      <p className="filter-item__name">
        <span>{name}</span>
      </p>
      <div className="filter-body">
        {renderCheckbox}
      </div>
    </div>
  );
}
